(function($){
  $('.document__image').on('load', function() {
    $('.documents-listing .sv-g').masonry({
      columnWidth: $('.documents-listing__list .sv-u-1').eq(0).outerWidth()
    });
  });
})(jQuery);
